import * as Yup from "yup";

export function initialValues(level) {
  return {
    name: level?.name || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
  });
}
